//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * 0.000001\n\
 *\n\
 * @name czm_epsilon6\n\
 * @glslConstant\n\
 */\n\
const float czm_epsilon6 = 0.000001;\n\
";